import { getData as apiGetData } from 'api/Api'
import {
  addArray as addUsersArray
} from 'store/redux/users'

type Payload = {
  userIds: number[];
}

const fetchUsersByArray = (payload: Payload) => async dispatch => {
  const { userIds } = payload

  dispatch(addUsersArray(userIds.map(id => ({
    id,
    isLoaded: false,
    isLoading: true
  }))))

  const { Users } = await apiGetData('UsersByArray', {
    query: userIds.map(userId => ({ id: userId }))
  })

  dispatch(addUsersArray(Users.filter(User => !!User).map(User => ({
    id: User.Id,
    name: User.Name,
    email: User.Email,
    profileKey: User.ProfileKey,
    licenseType: User.LicenseType,
    isActive: User.Active,
    isLoaded: true,
    isLoading: false
  }))))
}

export default fetchUsersByArray
